import styled from 'styled-components';
import { rem } from 'polished';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "tf3rct-0"
})(["left:50%;padding:", ";position:absolute;transform:translateX(-50%);top:0;width:100%;z-index:2;"], rem(16));
export default Container;